import { Controller } from "@hotwired/stimulus"

// The auto-advance setting in the test runner (courses/test_practices/show), on the page
// container so it outlives the `test-results-form` frame swaps:
//   - notice: "moved on automatically · Change", rendered (hidden) on the question the
//     runner skipped to. Shown for a learner's first NOTICE_LIMIT skips in this browser;
//     after that the header button is enough. Using the setting retires it at once.
//   - panel: the header popover (test_practices/_auto_advance_control). Its form posts
//     the source for Auto Advance Changed — `runner_notice` while opened from the notice.
const NOTICE_LIMIT = 5
const COUNT_KEY = "autoAdvanceNoticeCount"

export default class extends Controller {
  static targets = ["notice", "source"]

  noticeTargetConnected(element) {
    const count = this.count()
    if (count >= NOTICE_LIMIT) {
      element.remove()
      return
    }
    this.store(count + 1)
    element.hidden = false
  }

  // "Change" opens the panel natively (popovertarget); this only tags where from.
  fromNotice() {
    this.retireNotice()
    this.setSource("runner_notice")
  }

  panelToggled(event) {
    if (event.newState === "closed") this.setSource("runner")
  }

  chosen() {
    this.retireNotice()
  }

  retireNotice() {
    this.store(NOTICE_LIMIT)
  }

  setSource(value) {
    this.sourceTargets.forEach((field) => { field.value = value })
  }

  count() {
    try { return parseInt(window.localStorage.getItem(COUNT_KEY), 10) || 0 } catch (_e) { return NOTICE_LIMIT }
  }

  // localStorage can throw (private mode, blocked site data): the notice then stays off.
  store(value) {
    try { window.localStorage.setItem(COUNT_KEY, String(value)) } catch (_e) { /* see count */ }
  }
}
